import { RaffleInitResponse, RaffleParticipant } from "@/apps/raffle/types";

export const RUBLE_SIGN = "\u20bd";

export const formatMoney = (amount: number) =>
  new Intl.NumberFormat("ru-RU").format(amount);

export const sortParticipantsByChance = (participants: RaffleParticipant[]) =>
  [...participants].sort((first, second) => {
    const ridesDifference = second.rides - first.rides;

    return ridesDifference || first.rank - second.rank;
  });

export const getCurrentParticipantIndex = (
  _raffle: RaffleInitResponse | null,
  participants: RaffleParticipant[]
) => participants.findIndex((participant) => participant.is_me);

export const getRaffleDaysLeft = (periodEnd: string, now = Date.now()) => {
  const periodEndTime = new Date(periodEnd).getTime();

  if (Number.isNaN(periodEndTime)) {
    return 0;
  }

  const dayMs = 24 * 60 * 60 * 1000;

  return Math.max(0, Math.ceil((periodEndTime - now) / dayMs));
};

export const getRaffleTimeLeft = (periodEnd: string, now = Date.now()) => {
  const periodEndTime = new Date(periodEnd).getTime();

  if (Number.isNaN(periodEndTime)) {
    return {
      days: 0,
      hours: 0,
      minutes: 0,
      totalMs: 0,
    };
  }

  const totalMs = Math.max(0, periodEndTime - now);
  const minuteMs = 60 * 1000;
  const hourMs = 60 * minuteMs;
  const dayMs = 24 * hourMs;

  return {
    days: Math.ceil(totalMs / dayMs),
    hours: Math.floor(totalMs / hourMs),
    minutes: Math.max(1, Math.ceil(totalMs / minuteMs)),
    totalMs,
  };
};

export const formatRaffleFinishedAt = (drawnAt: string) =>
  new Intl.DateTimeFormat("ru-RU", {
    day: "numeric",
    month: "long",
    hour: "numeric",
    minute: "2-digit",
  }).format(new Date(drawnAt));

export const formatMonthDay = (date: Date) =>
  new Intl.DateTimeFormat("ru-RU", {
    day: "numeric",
    month: "long",
  }).format(date);

export const formatRafflePeriod = (start: string, end: string) => {
  const startDate = new Date(start);
  const endDate = new Date(end);
  const isSameMonth =
    startDate.getFullYear() === endDate.getFullYear() &&
    startDate.getMonth() === endDate.getMonth();

  if (isSameMonth) {
    return `${startDate.getDate()}–${formatMonthDay(endDate)}`;
  }

  return `${formatMonthDay(startDate)} – ${formatMonthDay(endDate)}`;
};
